export const truncate = (text: string, length: number): string => {
	if (text.length <= length) return text;

	const index = text.indexOf(' ', length);

	return index === -1 ? text : `${text.substring(0, index)}…`;
};
